import './LegalPage.css';
import privacyBanner from '../assets/images/legal-privacy-banner.jpg';
import LegalContent from '../components/LegalContent';
import privacyContent from '../content/privacyContent';

function PrivacyPolicy() {
  return (
    <>
      <section className="legal-banner legal-banner-privacy">
        <div
          className="legal-banner-img"
          style={{ backgroundImage: `url(${privacyBanner})` }}
        />
        <p className="legal-banner-title">Privacy Policy</p>
      </section>
      <section className="section">
        <div className="container legal-page">
          <span className="eyebrow">Legal</span>
          <LegalContent blocks={privacyContent} />
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
